import React from "react";

import Button from "../../ui/Button";
import { usePinnedItem } from "../../hooks/usePinnedItems";
import { useToast } from "../common/ToastProvider";

const buildErrorMessage = (error) =>
  error?.response?.data?.detail || error?.message || "Unable to update pin state.";

export default function PinButton({ itemType, itemId, summary, style }) {
  const toast = useToast();
  const { isPinned, isLoading, isSubmitting, error, toggle } = usePinnedItem({
    itemType,
    itemId,
    summary,
  });

  const busy = isLoading || isSubmitting;
  const label = isPinned ? "Pinned" : "Pin to My Overview";
  const ariaLabel = isPinned ? "Unpin from My Overview" : "Pin to My Overview";

  return (
    <Button
      type="button"
      variant={isPinned ? "primary" : "secondary"}
      onClick={() => {
        if (!busy) {
          toggle().catch((nextError) => {
            toast.error(buildErrorMessage(nextError));
          });
        }
      }}
      disabled={busy}
      loading={busy}
      aria-label={ariaLabel}
      aria-pressed={isPinned}
      title={error ? buildErrorMessage(error) : ariaLabel}
      style={style}
    >
      {label}
    </Button>
  );
}
